module.exports = __webpack_public_path__ + "static/ModernEra-Regular-5af04b53b453cbb23627b0262d2e2f50.woff2";